import { useEffect, useState } from "react";
import { useUserSettings } from "../../toolympus/components/Settings/UserSettingsContext";
import moment from "moment";
import { FieldType, Schema } from "../../toolympus/hooks/useSchema";
import { DateInternalFormat } from "../../toolympus/api/datetimeUtil";

export const SettingsApiPath = "/api/app-settings";

export const StatusDateCurrentKey = "status_date_current";
export const StatusDatePrevKey = "status_date_prev";

export const ProcessStatusDateCurrentKey = "status_date_process_current";
export const ProcessStatusDatePrevKey = "status_date_process_prev";

export const statusDateLabel = (d: string) => {
  const dd = moment(d);
  return `${dd.format("DD.MM.YY")}`;
}

export interface EditingSettings {
  editing_buffer_days?: number;
  editing_speed_pages_per_day?: number;
  editing_support?: string[];
}

const SettingsSchema: Schema = {
  [StatusDateCurrentKey]: { type: FieldType.date, label: "Текущая дата статуса"},
  [StatusDatePrevKey]: { type: FieldType.date, label: "Предыдущая дата статуса"},
  [ProcessStatusDateCurrentKey]: { type: FieldType.date, label: "Текущая дата статуса"},
  [ProcessStatusDatePrevKey]: { type: FieldType.date, label: "Предыдущая дата статуса"},

  editing_buffer_days: { type: FieldType.number, label: "Редактура: буффер (дней)" },
  editing_speed_pages_per_day: { type: FieldType.number, label: "Редактура: скорость (стр/д)" },
  editing_support: { type: FieldType.dictionarySelectMulti, dictionary: "ProjectSupportActors", label: "Редактура: поддержка" },
}

export const useAppSettings = () => {
  const settings = useUserSettings();

  useEffect(() => {
    settings.ensureLoaded();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [changes,setChanges] = useState<Record<string,any>>({});
  useEffect(() => {
    const timeout = setTimeout(async () => {
      await settings.updateGlobal(changes);
      setChanges({});
    }, 1000);
    return () => clearTimeout(timeout);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changes]);

  const hasChanges = Object.keys(changes).length > 0;

  const advanceStatusDatesProject = () => {
    const curr = moment(settings.global[StatusDateCurrentKey]);
    const next = curr.add(2, "weeks").format(DateInternalFormat);
    setChanges({
      [StatusDatePrevKey]: settings.global[StatusDateCurrentKey],
      [StatusDateCurrentKey]: next,
    })
  }

  const advanceStatusDatesProcess = () => {
    const curr = moment(settings.global[ProcessStatusDateCurrentKey]);
    const next = curr.add(2, "weeks").format(DateInternalFormat);
    setChanges({
      [ProcessStatusDatePrevKey]: settings.global[ProcessStatusDateCurrentKey],
      [ProcessStatusDateCurrentKey]: next,
    })
  }

  return {
    ...settings,
    global:  hasChanges ? { ...settings.global, ...changes } : settings.global,
    hasChanges,
    update: (c: Record<string,any>) => setChanges(x => ({ ...x, ...c })),

    advanceStatusDatesProject,
    advanceStatusDatesProcess,

    schema: SettingsSchema,
  };
}
